import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import UserPrefsContext from '../../context/UserPrefs/UserPrefsContext';
import EVIncentives from './../../components/EVIncentives/EVIncentives';
import EVJumbotron from '../../client_customizations/components/EVJumbotron/EVJumbotron';
import CostOfOwnership from '../../client_customizations/components/CostOfOwnership/CostOfOwnership';
import getPaymentDetails from './../../functions/vehicle/getPaymentDetails';

import LoadingSpinner from './../../components/LoadingSpinner/LoadingSpinner';
import { FormatCarName } from '../../utils/Helpers/Format';

const EV = ({
  electricVehicles,
  dealerLocations,
  userLocation,
  tabId,
  ip,
  uuid,
  zipcode,
}) => {
  const { evId } = useParams();
  const userPrefs = useContext(UserPrefsContext);

  let car = null;
  let paymentDetails = {};

  if (electricVehicles && evId) {
    car = electricVehicles.find((ev) => ev.handle === evId);
    if (car) {
      paymentDetails = getPaymentDetails(
        car,
        userPrefs.get('monthsOfOwnership'),
        userPrefs.get('interestRateAsBasisPoints'),
        userPrefs.get('milesDrivenAnnually'),
        userPrefs.get('salesTax'),
        userPrefs.get('downPayment')
      );
    }
  }

  useEffect(() => {
    document.title = car ? `${FormatCarName(car)}` : '';
  }, [car]);

  if (!electricVehicles) {
    return (
      <div className="container text-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!car) {
    return (
      <div className="container text-center">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <>
      <EVJumbotron
        car={car}
        incentives={car.incentives}
        paymentDetails={paymentDetails}
      />
      <div className="container container-cost">
        <CostOfOwnership
          cars={[car, car.equivalent_gas_vehicle]}
          zipcode={zipcode}
        />
      </div>

      <EVIncentives incentives={car.incentives} car={car} zipcode={zipcode} />
    </>
  );
};

export default EV;

EV.propTypes = {
  electricVehicles: PropTypes.array,
  userLocation: PropTypes.object,
  ip: PropTypes.string,
  uuid: PropTypes.string,
  zipcode: PropTypes.string,
};
